import React from 'react';

interface ColorPaletteProps {
  colors: string[];
  selectedIndex: number;
  onSelect(index: number): void;
  className?: string;

  secondary?: boolean;
  onToggleSecondary?: () => void;

  disableSelection?: boolean;
}

const ColorPalette: React.FC<ColorPaletteProps> = ({
  colors,
  selectedIndex,
  onSelect,
  className,
  secondary,
  onToggleSecondary,
}) => {
  return (
    <div className={`color-palette ${className || ''}`}>
      <div className="palette-colors">
        {colors.map((c, i) => (
          <button
            key={i}
            type="button"
            className={`palette-color ${i === selectedIndex ? 'active' : ''} `}
            style={{ backgroundColor: c }}
            aria-pressed={i === selectedIndex}
            onClick={() => onSelect(i)}
            title={c}
          />
        ))}

        {onToggleSecondary && (
          <button
            type="button"
            className={`palette-color palette-toggle ${secondary ? 'toggled' : ''}`}
            onClick={onToggleSecondary}
            aria-pressed={!!secondary}
            aria-label={secondary ? 'Secondary palette' : 'Primary palette'}
            title={secondary ? 'Secondary palette' : 'Primary palette'}
          >
            {/* Ikon istället för text */}
            <svg viewBox="0 0 16 16" className="palette-toggle-icon" aria-hidden="true">
              <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default ColorPalette;